import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-category-links',
  templateUrl: './category-links.component.html',
  styleUrls: ['./category-links.component.css']
})
export class CategoryLinksComponent implements OnInit {
    public categoryKeynoBelongTo: string;

    public categoryLinkKeyno: string;

    public productCountButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'products',
            gotoParms: () => ({
                argtype: 'category_keyno',
                argvalue: this.categoryKeynoBelongTo
            })
        }
    ];

    public selectedBgEdit: string = 'structure';

    public belongTo?: BelongTo;

    public linkCategory?: LinkCategory;

    public itemsListCategoryLinks: Item[] = [];

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    public deletingLink = false;

    public deletingCategory = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.categoryKeynoBelongTo = this.stateService.getStateParams()['category_keyno_belongto'];
        this.categoryLinkKeyno = this.stateService.getStateParams()['categorylink_keyno'];
    }

    private async loadBelongTo() {
        if (!!this.categoryKeynoBelongTo) {
            this.belongTo = (await this.datatask.Post(630, { category_keyno: this.categoryKeynoBelongTo }))[0];
        }
    }

    private async loadLinkCategory() {
        if (this.categoryLinkKeyno !== '0') {
            this.linkCategory = (await this.datatask.Post(634, { categorylink_keyno: this.categoryLinkKeyno }))[0];
        }
    }

    private async loadTranslations() {
        if (!this.belongTo) return;
        if (!this.categoryKeynoBelongTo) return;

        if (this.belongTo.category_keyno !== '0') {
            this.inputListLanguages = await this.datatask.Post(704, { category_keyno: this.categoryKeynoBelongTo });
        }
    }

    private async loadCategories() {
        if (!!this.categoryKeynoBelongTo) {
            this.itemsListCategoryLinks = await this.datatask.Post(629, { category_keyno_belongto: this.categoryKeynoBelongTo });
        }
    }

    public async saveChanges() {
        if (!!this.belongTo && !!this.categoryKeynoBelongTo && !!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(637, {
                    category_keyno: this.categoryKeynoBelongTo,
                    category_name: this.belongTo.category_name
                }))[0];

                if (response?.status_no !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.status_message
                    });
                } else {
                    const response = (await this.datatask.Post(705, { records: this.inputListLanguages }))[0];
                    
                    if (response?.status_no !== '') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            translateTitle: true,
                            message: response.status_message
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteCategoryLink() {
        if (!!this.categoryLinkKeyno) {
            try {
                this.deletingLink = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(633, { categorylink_keyno: this.categoryLinkKeyno }))[0];

                    if (response?.status_no !== '') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            translateTitle: true,
                            message: response.status_message
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deletingLink = false;
            }
        }
    }

    public async deleteCategory() {
        if (!!this.categoryKeynoBelongTo) {
            try {
                this.deletingCategory = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(635, { category_keyno: this.categoryKeynoBelongTo });

                    this.stateService.back();
                }
            } finally {
                this.deletingCategory = false;
            }
        }
    }

    private async init() {
        await this.loadBelongTo();
        this.loadLinkCategory();
        this.loadTranslations();
        this.loadCategories();
    }

    ngOnInit() {
        this.init();
    }
}

interface BelongTo {
    category_keyno: string;
    category_name: string;
    orderby: string;
    item_badge: string;
}

interface LinkCategory {
    categorylink_keyno: string;
    category_keyno: string;
    category_keyno_belongto: string;
    category_name: string;
    belongto_name: string;
}

interface LanguageItem {
    category_keyno: string;
    category_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
